<doc>
  @desc:   布局 - 导航组件
  @author:  
</doc>
<template>
  <div class="navbar-wrapper">
    <div class="navbar-content flex flex-align-center">
      <div class="navbar-tab flex flex-align-center" v-if="tabShow">
        <template v-for="(item, index) in langConfig.txtLang[langConfig.curLang]['NAV_TAB']">
          <span :class="tab*1==item.id*1 ? 'on' : ''" @click="tabClick(item.id, item.path)" :key="index"><b>{{ item.name }}<i class="icon-badge" v-if="item.id==1&&getFavNum()>0">{{getFavNum()}}</i></b></span>
        </template>
        <!-- <span :class="tab==0 ? 'on' : ''" @click="tabClick(0)"><b>Scores</b></span>
        <span :class="tab==1 ? 'on' : ''" @click="tabClick(0)"><b>Favorites</b></span>
        <span :class="tab==2 ? 'on' : ''" @click="tabClick(0)"><b>Leagues</b></span>
        <span :class="tab==3 ? 'on' : ''" @click="tabClick(0)"><b>Transfer</b></span>
        <span :class="tab==4 ? 'on' : ''" @click="tabClick(0)"><b>Prediction</b></span>
        <span :class="tab==5 ? 'on' : ''" @click="tabClick(0)"><b>News</b></span> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getUser } from '@/api/api';
  export default {
    props: {
      tab: {
        type: Number,
        default: 0
      },
      favLiveNum: {
        type: Number,
        default: 0
      },
      follow: {
        type: Object,
        default: () => {},
      },
      footballMatch: {
        type: Object,
        default: () => {},
      },
      isLogin: {
        type: Boolean,
        default: false
      },
    },
    
    data(){
      return{
        //tabs:0,
        //favNum: 0,
        tabShow: false,
        loginShow: false,
        liveSate: [1,2,3,5,10,11,16], //比赛进行中
      }
    },
    mounted(){
      // this.$watch('tab', (val) => {
      //   this.tabs = val;
      // });
      setTimeout(()=>{
        this.tabShow = true;
      }, 10)
    },
    methods: {
      tabClick(val, path){
        let _tab = this.tab, _val =val, _path=path;
        if(_tab != _val){
          if(_val == 1){

            let param = {
              userToken: '',
              
            }

            let _userInfo = this.common.getCookie('userInfo');
				
            if(typeof(_userInfo) != 'undefined' && _userInfo != null){
              _userInfo = JSON.parse(_userInfo);
              param.userToken = _userInfo.token;
            }

            getUser(param).then((res) => {
              let _res = res;
        
              if(_res.state == 403){ // 未登录
                this.loginShow = true;
                this.$emit('onChangLogin', this.loginShow);
                this.common.delCookie('userInfo');
                return;
              }
        
              if(_res.state != 200){
                console.log(_res.msg);
                return;
              }

              this.$router.push(_path);
        
            }).catch((res) => {
              console.error(res)
            })

          }else{
            this.$router.push(_path);
          }
        }
      },

      // 关注数
      getFavNum(){
        // 关注
        let _favLiveNum = this.favLiveNum, _num = 0;

        if(_favLiveNum > 0){
          return _favLiveNum;
        }

        // 比分
        if(typeof(this.follow) != 'undefined' && typeof(this.footballMatch) != 'undefined'){
          let _follow = this.follow, _footballMatch = this.footballMatch, _liveState = this.liveSate;

          if(Object.keys(_follow).length > 0){
            for(let key in _follow){
              if(typeof(_footballMatch[key]) != 'undefined'){
                let _state = _footballMatch[key].state;
                if(_liveState.includes(_state)){
                  _num++;
                }
              }
            }
          }
        }

        return _num;
      },
    },
    watch:{
      'isLogin': {
        immediate:true,
        handler(val){
          this.loginShow = val;
        }
      }
    }
  }
</script>

<style lang="less">
@import '~@/style/navbar/navbar.less';
</style>


// WEBPACK FOOTER //
// ./src/components/navbar.vue